import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'queryFilter' })

export class QueryFilterPipe implements PipeTransform {
  transform(value: any, input: string) {
    input = input.trim();
    if (input) {
      input = input.toLowerCase();
      return value.filter(function (obj: any) {
        if (obj.reportName.toLowerCase().includes(input)) {
          return obj;
        }
      })
    }
    return value;
  }
}
